import React from "react";
import { motion } from "framer-motion";

/**
 * Pulsating blood-red signal dot.
 * Used as the brand's "live" indicator: hero, footer, sticky section labels.
 */
export const BlinkingDot = ({ size = 7, glow = true, className, style }) => (
    <motion.span
        aria-hidden="true"
        animate={{ opacity: [1, 0.2, 1] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        className={className}
        style={{
            display: "inline-block",
            width: size,
            height: size,
            background: "var(--signal)",
            boxShadow: glow ? "0 0 4px rgba(193, 18, 31, 0.55)" : undefined,
            ...style,
        }}
    />
);

export default BlinkingDot;
